import { Result } from '../../Shared/Protocol/protocol-result'
import { HubDashboardApiRemoteService } from '../../Services/api/dashboard/hub-dashboard-service'
import {
  IHubDashboardChartItem,
  IHubDashboardOrderStatusGroup,
  ILoadHubDashboardChartResult,
  ILoadHubOrdersTimelineResult,
} from '../../Services/api/dashboard/hub-dashboard.interface'

export class LoadHubDashboardUseCase {
  constructor(private readonly hubDashboardService: HubDashboardApiRemoteService) {}

  public async loadModuleTotal(endpoint: string): Promise<Result<number>> {
    return this.hubDashboardService.getListTotal(endpoint)
  }

  public async loadOrdersChart(
    groups: IHubDashboardOrderStatusGroup[],
  ): Promise<Result<ILoadHubDashboardChartResult>> {
    const aggregated = await this.hubDashboardService.getOrdersByStatusAggregated()

    if (aggregated.isFailure) {
      return Result.fail(aggregated.error ?? new Error('Não foi possível carregar pedidos por status.'))
    }

    const payload = aggregated.getValue()
    const apiGroups = payload?.groups

    if (!apiGroups?.length) {
      return Result.ok({
        data: groups.map((group) => ({ name: group.name, value: 0, fill: group.fill })),
        failed: false,
        usedAggregatedEndpoint: true,
      })
    }

    const byKey = new Map(
      apiGroups.map((group) => [
        String(group.key ?? group.label ?? group.name ?? '').trim().toLowerCase(),
        group.count ?? 0,
      ]),
    )
    const byLabel = new Map(
      apiGroups.map((group) => [
        String(group.label ?? group.name ?? '').trim().toLowerCase(),
        group.count ?? 0,
      ]),
    )

    const data: IHubDashboardChartItem[] = groups.map((group) => ({
      name: group.name,
      value: byLabel.get(group.name.trim().toLowerCase()) ?? byKey.get(String(group.key ?? '').trim().toLowerCase()) ?? 0,
      fill: group.fill,
    }))

    return Result.ok({ data, failed: false, usedAggregatedEndpoint: true })
  }

  public async loadOrdersTimeline(days = 30): Promise<Result<ILoadHubOrdersTimelineResult>> {
    const timeline = await this.hubDashboardService.getOrdersTimeline(days)

    if (timeline.isFailure) {
      return Result.fail(timeline.error ?? new Error('Não foi possível carregar tendência de pedidos.'))
    }

    const points = timeline.getValue()?.points ?? []

    return Result.ok({
      failed: false,
      data: points.map((point) => ({
        date: point.date,
        name: point.date,
        created: point.created ?? 0,
        completed: point.completed ?? 0,
        canceled: point.canceled ?? 0,
      })),
    })
  }
}
